














import Vue from "vue"

export default Vue.extend({
  props: {
    /**
     * 表示をPCのみにするかどうかを指定できる。
     */
    onlyPc: {
      type: Boolean,
      default: false,
    },
    isGrayBackground: {
      type: Boolean,
      default: false,
    },
  },
})
